"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexCenter, Media, Separator, SpaceBetween } from "@opensea/ui-kit";
import { useChainArch } from "@opensea/wallet";
import { useHideNavigationLayoutComponents } from "@/components/navigation/use-hide-navigation-layout-components";
import { useSubscriptionStatus } from "@/hooks/use-subscription/use-subscription-status";
import { AggregatorHoverable } from "./AggregatorHoverable";
import { NetworksHoverable } from "./NetworksHoverable";
import { PageFooterContainer } from "./PageFooterContainer";
import { PageFooterCurrencyToggle } from "./PageFooterCurrencyToggle";
import { PageFooterGwei } from "./PageFooterGwei";
import { PageFooterNativeCurrencyPrice } from "./PageFooterNativeCurrencyPrice";
import { PageFooterPersonaToggle } from "./PageFooterPersonaToggle";
import { PageFooterPrivacyPolicy } from "./PageFooterPrivacyPolicy";
import { PageFooterSocialLinks } from "./PageFooterSocialLinks";
import { PageFooterSupportLink } from "./PageFooterSupportLink";
import { PageFooterTermsOfService } from "./PageFooterTermsOfService";
import { PageFooterThemeToggle } from "./PageFooterThemeToggle";
import { PageFooterVolumeToggle } from "./PageFooterVolumeToggle";
import { SubscriptionLiveIndicator } from "./SubscriptionLiveIndicator";
const SEPARATOR = <Separator className="mx-4 h-4" orientation="vertical" />;
export function PageFooter() {
  const $ = _c(18);
  const result = useSubscriptionStatus();
  const hideNavigationLayoutComponents = useHideNavigationLayoutComponents();
  const chainArch = useChainArch();
  if (hideNavigationLayoutComponents) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SubscriptionLiveIndicator />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = Boolean(result) && SEPARATOR;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AggregatorHoverable />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Media greaterThanOrEqual="xl">{t2}{SEPARATOR}<NetworksHoverable />{SEPARATOR}</Media>;
    t4 = <PageFooterTermsOfService />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PageFooterPrivacyPolicy />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Media greaterThanOrEqual="2xl">{SEPARATOR}<PageFooterSocialLinks /></Media>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t1) {
    t7 = <FlexCenter>{t0}{t1}{t3}{t4}{SEPARATOR}{t5}{t6}</FlexCenter>;
    $[6] = t1;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <PageFooterNativeCurrencyPrice />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== chainArch) {
    t9 = chainArch === "EVM" && <>{SEPARATOR}<PageFooterGwei /></>;
    $[9] = chainArch;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <PageFooterSupportLink />;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <FlexCenter className="gap-2"><PageFooterThemeToggle /><PageFooterPersonaToggle /><PageFooterCurrencyToggle /><PageFooterVolumeToggle /></FlexCenter>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t9) {
    t12 = <FlexCenter>{t8}{t9}{SEPARATOR}{t10}{SEPARATOR}{t11}</FlexCenter>;
    $[13] = t9;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t12 || $[16] !== t7) {
    t13 = <PageFooterContainer><SpaceBetween className="w-full">{t7}{t12}</SpaceBetween></PageFooterContainer>;
    $[15] = t12;
    $[16] = t7;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  return t13;
}